import { jsx as _jsx } from "react/jsx-runtime";
import { __, _i } from "../../utils/i18n.js";
const A11yNotice = (param)=>{
    let { text, severity } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: `notice notice-${severity} inline below-h2 notice-alt`,
        style: {
            margin: "10px 0"
        },
        children: /*#__PURE__*/ _jsx("p", {
            children: _i(text, {
                aPerc: /*#__PURE__*/ _jsx("a", {
                    href: __("https://www.w3.org/TR/WCAG22/#perceivable"),
                    target: "_blank",
                    rel: "noreferrer"
                }),
                aEuMinimum: /*#__PURE__*/ _jsx("a", {
                    href: __("https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=celex:32019L0882"),
                    target: "_blank",
                    rel: "noreferrer"
                })
            })
        })
    });
};
export { A11yNotice };
